export const supportedLanguages = {
    en: 'English',
    es: 'Español',
    ru: 'Русский',
    uk: 'Українська',
};
